module.exports = __webpack_public_path__ + "img/login.b00f8f8d.png";